export default "__VITE_ASSET__42012cb0__"